{
  "aboutCluster": "Om nettverket",
  "accountSettings": "Kontoinnstillinger",
  "addEvent": "Legg til event",
  "advisors": "Rådgivere",
  "boardGroup": "Styringsgruppe",
  "businessDescription": "Virksomhetsbeskrivelse",
  "clusterManagement": "Ledelse",
  "companyInformation": "Selskapsinformasjon",
  "contactDetails": "Kontaktdetaljar",
  "contactInformation": "Kontaktinformasjon",
  "contacts": "Kontakter",
  "economyEsaReporting": "Økonomi/ESA-rapportering",
  "fastContactRegistration": "Rask kontaktregistrering",
  "fastInKindRegistration": "Rask eigeninnsatsregistrering",
  "fastMemberRegistration": "Rask medlemsregistrering",
  "focusAreas": "Fokusområder",
  "grunndata": "Grunndata",
  "inkindOverview": "Oversikt eigeninnsats",
  "interestAreas": "Interesseområder",
  "mainGoals": "Hovedmål",
  "memberContribution": "Medlemsbidrag og eigeninnsats",
  "memberInformation": "Medlemsinformasjon",
  "membershipFees": "Medlemskontingent",
  "projectCategories": "Prosjektkategorier",
  "timeRates": "Timesats",
  "visionMission": "Visjon og Misjon",
  "yourProfile": "Profilen din",
  "accessControl": "Tilgangsstyring"
}
